import { createContext } from 'react';

const EmployeeContext = createContext(null);

export default EmployeeContext;